export default __webpack_public_path__ + "static/media/opay.7c272745.png";